import { NextSeo } from 'next-seo';

const Breadcrumb = ({ items }) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => {
      const listItem: any = {
        '@type': 'ListItem',
        position: index + 1,
      };

      if (item.url) {
        listItem.item = {
          '@id': item.url,
          name: item.name,
        };
      } else {
        listItem.name = item.name;
      }

      return listItem;
    }),
  };

  return (
    <NextSeo
      // @ts-ignore
      additionalSchema={[
        {
          '@context': 'https://schema.org',
          ...structuredData,
        },
      ]}
    />
  );
};

export default Breadcrumb;
